import React from "react";
import "./AV.css"
import Navbar from "../navbar/Navbar";
import Booking1 from "../booking/Booking1";

const AV=()=>{
    return(
        <div className="">
<Navbar/>
<Booking1/>
        </div>
    )
}

export default AV